import { QueryClient } from '@tanstack/react-query';

/**
 * @constant queryClient
 * @description Configuración del QueryClient de TanStack Query para el manejo del estado del servidor.
 * Incluye configuraciones por defecto para el manejo de errores, reintentos y caché.
 * Este QueryClient es compartido entre el host y los módulos remotos para garantizar
 * un comportamiento consistente y permitir el uso de TanStack Query en módulos federados.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Reintentar automáticamente las consultas fallidas
      retry: 1,
      // Al volver a una pantalla (montarla) siempre se pide de nuevo en segundo plano, mostrando la caché al instante:
      // nadie ve datos rancios hasta recargar la página. Si otra pantalla ya la está pidiendo, se reusa esa petición.
      refetchOnMount: 'always',
      // Con la pantalla abierta, regresar a la pestaña o recuperar la conexión solo vuelve a pedir lo que ya está viejo
      // según el staleTime de la consulta
      refetchOnWindowFocus: true,
      // 5 minutos por defecto: cambiar de pestaña no reinicia los formularios abiertos que se siembran de una consulta
      // ni repite las consultas paginadas pesadas. Las que deben estar al día en cada regreso (el buzón, por ejemplo)
      // fijan su propio `staleTime: 0`
      staleTime: 5 * 60 * 1000,
      // Mantener los datos en caché sin usar por 10 minutos
      gcTime: 10 * 60 * 1000,
    },
    mutations: {
      // Sin reintento: la mayoría de las mutaciones no son idempotentes; el hook que lo necesite debe pedirlo explícitamente
      retry: false,
    },
  },
});

